export * from './foundation-type-1.component';